export const getInitials = (userName?: string) => {
  return userName?.split(" ")
    .map(x => x.trim())
    .filter(Boolean)
    .map(x => x.slice(0, 1)
      .toUpperCase())
    .slice(0, 2)
    .join("");
};
